export const RATINGS_INITIAL_STATE = {
    ultimoRatingEmissao: { data_validade: "", fonte: "", rating: "" },
    ultimoRatingDevedor: { data_validade: "", fonte: "", rating: "" },
    ultimoPrecosProcessados: {
        data_referencia: "",
        spread_credito: "",
        percentual_pupar: "",
    },
    ultimoNegocio: { data_referencia: "", pupar: "", spread_credito: "" },
    ultimoIndiceLiquidez: { data_referencia: "", indice_liquidez: "" },
    ultimoCreditoEmissao: {
        data_referencia: "",
        evento_credito: "",
        score_evento: "",
    },
    ultimoEventoCreditoDevedor: {
        data_referencia: "",
        evento_credito_devedor: "",
        score_evento: "",
    },
    isLoading: false,
    errors: {
        ultimoRatingEmissao: null,
        ultimoRatingDevedor: null,
        ultimoPrecosProcessados: null,
        ultimoNegocio: null,
        ultimoIndiceLiquidez: null,
        ultimoCreditoEmissao: null,
        ultimoEventoCreditoDevedor: null,
    },
    isEmpty: {
        ultimoRatingEmissao: true,
        ultimoRatingDevedor: true,
        ultimoPrecosProcessados: true,
        ultimoNegocio: true,
        ultimoIndiceLiquidez: true,
        ultimoCreditoEmissao: true,
        ultimoEventoCreditoDevedor: true,
    },
}
